export const getEntities = state => state.entities;
export const getApiHOCs = state => state.apiHOCs;



// WEBPACK FOOTER //
// ./src/selectors/index.js